// AUTO-GENERATED by scripts/sync-wbs.js — do not edit manually.
// Source: WBS.md
// Last synced: 2026-06-11T09:10:45.258Z
//
// To refresh: from workspace root, run  `node scripts/sync-wbs.js`

export const INFRA = {
  "id": "INFRA",
  "name": "Infrastructure",
  "days": 5.5,
  "status": "complete"
};

export const MODULES = [
  {
    "id": "T2T-01",
    "name": "Workflow Builder",
    "priority": "P1",
    "days": 13,
    "status": "complete"
  },
  {
    "id": "T2T-01+",
    "name": "Guided Workflow (G1-G6)",
    "priority": "P1",
    "days": 9.5,
    "status": "complete"
  },
  {
    "id": "T2T-02",
    "name": "UX Layer",
    "priority": "P1",
    "days": 6,
    "status": "complete"
  },
  {
    "id": "T2T-INT",
    "name": "Integration Layer",
    "priority": "P1",
    "days": 22,
    "status": "complete"
  },
  {
    "id": "T2T-03",
    "name": "Vendor Master",
    "priority": "P1",
    "days": 4.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-SG1",
    "name": "Screen Groups — 6 SAP-aligned views",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-SG2",
    "name": "Screen Groups — Role × Workflow access matrix",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-SG3",
    "name": "Screen Groups — Admin configuration UI",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-WF1",
    "name": "Change Workflow (4-level) with Block-in-cycle",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-WF2",
    "name": "Extend Workflow (4-level)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-WF3",
    "name": "Seasonal / Fast-Track 2-level workflow",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-SLA1",
    "name": "Per-role SLA configuration table",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-SLA2",
    "name": "SLA enforcement + alert escalation email",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-USR1",
    "name": "Vendor Role Assignments admin screen",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-MN1",
    "name": "WATI WhatsApp + email notifications (all workflow events)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-MN2",
    "name": "Deep-link login_url construction",
    "priority": "P2",
    "days": 0.3,
    "status": "complete"
  },
  {
    "id": "T2T-03-KYC1",
    "name": "KYC re-verification schedule + auto-block",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-DOC1",
    "name": "Document expiry alert cron (90/60/30/15/7 days)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-MM1",
    "name": "Mismatch severity rules + badge enforcement",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL1",
    "name": "Junk character validation (field-level)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL2",
    "name": "Min / Max length validation (field-level)",
    "priority": "P2",
    "days": 0.3,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL3",
    "name": "Default / conditional mandatory fields",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL4",
    "name": "Pattern validation (PAN / GSTIN / Mobile)",
    "priority": "P2",
    "days": 0.3,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL5",
    "name": "PAN TDS logic — FC1/FC2 + Section 194C",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-VAL6",
    "name": "Deduplication matching engine (Jaro-Winkler)",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-DC1",
    "name": "Document upload API + storage + expiry",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-03-DC2",
    "name": "Address child records CRUD",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-DC3",
    "name": "Bank account child records CRUD",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-DC4",
    "name": "Audit trail GET endpoint",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-03-DC5",
    "name": "Tenant lookup tables (company codes, plants, payment terms)",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-04",
    "name": "Kanban, List & Calendar Views",
    "priority": "P2",
    "days": 9.5,
    "status": "complete"
  },
  {
    "id": "T2T-04-P1",
    "name": "P1 — Foundation + List View + Slide-Over",
    "priority": "P2",
    "days": 2,
    "status": "complete"
  },
  {
    "id": "T2T-04-P2",
    "name": "P2 — Advanced Filters + Saved Views",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-04-P3",
    "name": "P3 — AI Summary + Chat + Bulk Actions",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-04-P4",
    "name": "P4 — Kanban Board + Form Field Tags",
    "priority": "P2",
    "days": 2,
    "status": "complete"
  },
  {
    "id": "T2T-04-P5",
    "name": "P5 — By Status + By Assignee + SAP Auto-Move",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-04-P6",
    "name": "P6 — Calendar View",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-04-P7",
    "name": "P7 — Mobile + Polish",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-04-P8",
    "name": "Request Edit in SlideOver — admin inline edit",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-04-P9",
    "name": "Kanban card enhancements — action buttons + SLA label",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-05",
    "name": "In-App Chat & Notifications",
    "priority": "P2",
    "days": 8,
    "status": "in_progress"
  },
  {
    "id": "T2T-05-C1",
    "name": "C1 — DB tables + core message APIs",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-05-C2",
    "name": "C2 — File attachments + virus scan",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-05-C3",
    "name": "C3 — @Mention picker + late-join",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-05-C3-UI",
    "name": "C3-UI — EmbeddedChat (manual refresh)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-05-C4",
    "name": "C4 — Real-time SSE + typing + reconnect",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-05-C5",
    "name": "C5 — 3-channel notifications + bell + view-all page",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-05-C6",
    "name": "C6 — Vendor portal + multiple contacts",
    "priority": "P2",
    "days": 1.5,
    "status": "complete"
  },
  {
    "id": "T2T-05-C7",
    "name": "C7 — Polish (overflow, mute, PDF export, vendor attachments)",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-01",
    "name": "T2TTopNav fires active-delegation 403",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-02",
    "name": "RequestDetails PropType mismatch",
    "priority": "P2",
    "days": 0.02,
    "status": "complete"
  },
  {
    "id": "BUG-03",
    "name": "KYC monitor cron uses wrong column",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-04+05",
    "name": "@mention does not invite users to chat thread",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-07",
    "name": "Mobile Number missing from Add User modal",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-08",
    "name": "User Import CSV missing Mobile + Reporting Manager columns",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-09",
    "name": "Dropdown options editor: row-based replacement for pipe-syntax textarea",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-46",
    "name": "Pincode auto-fill + mismatch validation + monthly refresh cron",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "BUG-47",
    "name": "(deferred) Pincode pre-seed via bundled CSV",
    "priority": "P2",
    "days": 0.5,
    "status": "planned"
  },
  {
    "id": "BUG-49",
    "name": "Backend country lookup table + API-driven country dropdowns",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-50",
    "name": "Phone-code auto-prefix + per-country phone-length validation",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-53",
    "name": "Bank dropdown + IFSC verification on Finance tab",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-54",
    "name": "(deferred) Monthly IFSC refresh cron",
    "priority": "P2",
    "days": 0.25,
    "status": "planned"
  },
  {
    "id": "BUG-52",
    "name": "(deferred) OTP verification for mobile + email on vendor sign-up",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  },
  {
    "id": "BUG-51",
    "name": "(deferred) Currency auto-default per country on Finance tab",
    "priority": "P2",
    "days": 0.25,
    "status": "planned"
  },
  {
    "id": "BUG-48",
    "name": "Pincode auto-fill for public /vendor-signup form",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-45",
    "name": "Help & Guidance — Reset Hints feedback + Replay Tutorial/Wizard menu items",
    "priority": "P2",
    "days": 0.03,
    "status": "complete"
  },
  {
    "id": "BUG-39",
    "name": "Workflow Builder System Action — replace Field Mapping textarea with row editor",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-40",
    "name": "Workflow Builder System Action — operation-specific target-field catalogue + static-value flag + transforms (deferred)",
    "priority": "P2",
    "days": 1.5,
    "status": "planned"
  },
  {
    "id": "BUG-41",
    "name": "Workflow Builder System Action — bidirectional mapping (capture SAP response back to form) (deferred)",
    "priority": "P2",
    "days": 1.5,
    "status": "planned"
  },
  {
    "id": "BUG-42",
    "name": "Workflow Builder — clarify SLA semantic for System Action stages (deferred)",
    "priority": "P2",
    "days": 0.05,
    "status": "planned"
  },
  {
    "id": "BUG-43",
    "name": "Workflow Builder System Action — payload preview + per-operation required-field validator (deferred)",
    "priority": "P2",
    "days": 1,
    "status": "planned"
  },
  {
    "id": "BUG-44",
    "name": "Workflow Builder System Action — idempotency key + last-error panel (deferred)",
    "priority": "P2",
    "days": 0.5,
    "status": "planned"
  },
  {
    "id": "BUG-36",
    "name": "Workflow Builder roles panel: Select all / Clear + counter (Option A)",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-37",
    "name": "Workflow Builder: user-level pre-assignment alongside roles (Option B)",
    "priority": "P2",
    "days": 0.75,
    "status": "complete"
  },
  {
    "id": "BUG-38",
    "name": "Workflow Builder: \"Copy approvers from another stage\" helper (deferred)",
    "priority": "P2",
    "days": 0.1,
    "status": "planned"
  },
  {
    "id": "BUG-35",
    "name": "Make Reports → Overview discoverable + rename \"Executive Dashboard\"",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-34",
    "name": "Team Overview: surface unassigned pending requests + link to Reports Tracker",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-32",
    "name": "User Performance: filters + sort + threshold colours + insight strip + workload chart",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-33",
    "name": "User Performance: drill-down page per user (deferred)",
    "priority": "P2",
    "days": 1.5,
    "status": "planned"
  },
  {
    "id": "BUG-30",
    "name": "Workflow Analytics: distinguish \"pick workflow\" from \"no data\" empty states",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-31",
    "name": "Integration Monitoring Dashboard: new Reports tab wiring 4 existing backend endpoints",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-29",
    "name": "Reports → Request Tracker: add Priority / Stage / Department / Submitted-by / SLA filters",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-28",
    "name": "Reports → Request Tracker: row click → request detail page",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-25",
    "name": "Bulk Vendor Upload: pre-flight dedup against existing vendor master",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-26",
    "name": "Bulk Vendor Upload: in-CSV + against-pending-requests dedup (deferred)",
    "priority": "P2",
    "days": 0.5,
    "status": "planned"
  },
  {
    "id": "BUG-27",
    "name": "Bulk Vendor Upload: side-by-side compare modal for fuzzy hits (deferred — Module-3 §12.4)",
    "priority": "P2",
    "days": 0.5,
    "status": "planned"
  },
  {
    "id": "BUG-24",
    "name": "Bulk Vendor Upload: clarify \"creates approval requests, not vendors\"",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-23",
    "name": "Bulk Vendor Upload: Download CSV Template silent-fails",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-22",
    "name": "Guidance: recording scripts for 13 admin-tab walkthrough videos",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-21",
    "name": "Per-page \"?\" help button + content map (Option A — guidance quick wins)",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-20",
    "name": "Channels admin: proper add/edit modal with provider + config",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-19",
    "name": "Notifications admin: add \"+ Add Notification\" + per-card channel pill",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-18",
    "name": "SLA Config: fix \"stage_id not allowed\" PUT bug + switch unit to minutes",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-17",
    "name": "Lookups → Currencies: country picker + currency symbol field",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-16",
    "name": "Vendor Sign-ups: View details modal before approve/reject",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-15",
    "name": "Centralize public-route whitelist (SessionProvider/authMonitor/useAuthGuard also broken)",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-14",
    "name": "AuthProvider redirects public vendor pages to login",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-13",
    "name": "Vendor sign-up form: expand public stage with safe address/business fields",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-12",
    "name": "Vendor Sign-ups admin: add Copy link + Email + Preview affordances",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-11",
    "name": "Field Key auto-syncs with Label edits + duplicate-key guard at save",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-10",
    "name": "Form Fields: insert-anywhere dividers (top, between, bottom)",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-55",
    "name": "SAP vendor code: hide on create, capture on sap_sync, dedupe on bulk",
    "priority": "P2",
    "days": 0.3,
    "status": "complete"
  },
  {
    "id": "BUG-56",
    "name": "Submit form: compact priority picker inline with Submit row",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-81",
    "name": "ErrorBoundary renders null on caught error → blank page on hard refresh + destructive auto-reload/auto-logout/console-monkey-patch",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-80",
    "name": "KYC monitor cron silently no-ops: \"rows is not iterable\"",
    "priority": "P2",
    "days": 0.02,
    "status": "complete"
  },
  {
    "id": "BUG-79",
    "name": "Express trust-proxy not set; rate-limit keys on proxy IP; can cause 429 blank-page",
    "priority": "P2",
    "days": 0.02,
    "status": "complete"
  },
  {
    "id": "QA-01",
    "name": "Full T2T regression sweep across all features/modules",
    "priority": "P2",
    "days": 1,
    "status": "planned"
  },
  {
    "id": "BUG-78",
    "name": "In-app chat: legacy requests show \"You're not part of this conversation\" for non-admin users (broken UNNEST(jsonb) in C1 resolver + partial-fill state on legacy data)",
    "priority": "P2",
    "days": 0.4,
    "status": "complete"
  },
  {
    "id": "BUG-77",
    "name": "Stage Properties: Specific Users checkboxes empty after refresh — propsForm.users never initialised",
    "priority": "P2",
    "days": 0,
    "status": "planned"
  },
  {
    "id": "BUG-76",
    "name": "Help & Guidance panel: 4 broken actions (Replay Tutorial/Wizard, Documentation, Contact Support)",
    "priority": "P2",
    "days": 0.08,
    "status": "complete"
  },
  {
    "id": "BUG-75",
    "name": "Logout always lands on OSIF login tab — T2T users should return to T2T tab",
    "priority": "P2",
    "days": 0.03,
    "status": "complete"
  },
  {
    "id": "BUG-74",
    "name": "Defensive refresh-error guard: public-route bypass for hard token-redirect",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-73",
    "name": "Vendor master: address/bank/tax tabs empty — projection on workflow approval only writes parent row",
    "priority": "P2",
    "days": 0.3,
    "status": "complete"
  },
  {
    "id": "BUG-72",
    "name": "Vendor detail actions all crash with \"NaN\" — wrong field name on vendor object",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-71",
    "name": "Dashboard upgrade: status donut + SLA gauge + priority bar + today tile + my-pending panel + greeting",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "BUG-70",
    "name": "Dashboard Workflows card has no search or status sub-filter",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-69",
    "name": "Request lifecycle gaps: SLA Breach/Due Today/High Priority chips broken; due_at never persisted on submit or transition",
    "priority": "P2",
    "days": 0.4,
    "status": "complete"
  },
  {
    "id": "BUG-68",
    "name": "Global footer (z-index 9999) covers bottom of every modal/drawer",
    "priority": "P2",
    "days": 0.02,
    "status": "complete"
  },
  {
    "id": "BUG-67",
    "name": "Filters panel: missing Critical priority + status/priority match case-sensitive against legacy data",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-66",
    "name": "Vendor Creation form: no document attachment UI (generic flow has it, vendor flow doesn't)",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "BUG-65",
    "name": "Vendor self-sign-ups disappear with no audit trail (reject is hard DELETE)",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-64",
    "name": "Calendar: requests with no effective SLA are dropped from response, never reach Undated tray",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-63",
    "name": "Kanban: card \"disappears\" after drag-drop confirm (board blanks during refetch)",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-62",
    "name": "Kanban reject modal hardcodes \"back to entry stage\" — no return-stage picker",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-61",
    "name": "Requests list/Kanban: SLA always \"No SLA\" + Assignee blank for role-based stages",
    "priority": "P2",
    "days": 0.25,
    "status": "complete"
  },
  {
    "id": "BUG-60",
    "name": "Request detail \"Request not found\" for cross-org approvers visible in queue",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-59",
    "name": "Backend PAN error message misleading: \"no special characters\" fires for case-only failures",
    "priority": "P2",
    "days": 0.05,
    "status": "complete"
  },
  {
    "id": "BUG-58",
    "name": "Vendor PAN validation: catch lowercase on-blur + PAN↔GSTIN cross-check",
    "priority": "P2",
    "days": 0.15,
    "status": "complete"
  },
  {
    "id": "BUG-57",
    "name": "Review modal: hidden fields + missing Partner Function section",
    "priority": "P2",
    "days": 0.1,
    "status": "complete"
  },
  {
    "id": "T2T-06",
    "name": "Purchase Order",
    "priority": "P2",
    "days": 5.5,
    "status": "planned"
  },
  {
    "id": "T2T-07",
    "name": "Budget & Capex",
    "priority": "P2",
    "days": 4.5,
    "status": "planned"
  },
  {
    "id": "T2T-08",
    "name": "Reporting",
    "priority": "P3",
    "days": 5,
    "status": "planned"
  },
  {
    "id": "T2T-09",
    "name": "Bulk Upload",
    "priority": "P2",
    "days": 3.5,
    "status": "complete"
  },
  {
    "id": "T2T-10",
    "name": "Finance & AP",
    "priority": "P3",
    "days": 3.5,
    "status": "planned"
  },
  {
    "id": "T2T-11",
    "name": "HR Onboarding",
    "priority": "P3",
    "days": 4,
    "status": "planned"
  },
  {
    "id": "T2T-12",
    "name": "Inventory",
    "priority": "P4",
    "days": 5,
    "status": "planned"
  },
  {
    "id": "T2T-13",
    "name": "AI Auditing",
    "priority": "P4",
    "days": 5,
    "status": "planned"
  },
  {
    "id": "T2T-GUIDE-EXPANSION",
    "name": "Guidance: per-feature tutorials + video walkthroughs (Option B)",
    "priority": "P3",
    "days": 15,
    "status": "planned"
  },
  {
    "id": "T2T-14-F1",
    "name": "Foundation — Budget Control Layer",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-14-F2",
    "name": "Foundation — GL Codes & Cost Centers",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-14-F3",
    "name": "Foundation — Request Types for 9 Processes",
    "priority": "P2",
    "days": 1,
    "status": "complete"
  },
  {
    "id": "T2T-14-F4",
    "name": "Foundation — 3-Way Match Engine",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-14-F5",
    "name": "Foundation — Sidebar Navigation Expansion",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-14-F6",
    "name": "Foundation — Dashboard Process Overview Cards",
    "priority": "P2",
    "days": 0.5,
    "status": "complete"
  },
  {
    "id": "T2T-15",
    "name": "Order to Cash (O2C)",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  },
  {
    "id": "T2T-16",
    "name": "Invoice & Bill (R2R)",
    "priority": "P2",
    "days": 2.5,
    "status": "planned"
  },
  {
    "id": "T2T-17",
    "name": "Budgeting Process",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  },
  {
    "id": "T2T-18",
    "name": "Logistics & Dispatch",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  },
  {
    "id": "T2T-19",
    "name": "Contractor Onboarding",
    "priority": "P2",
    "days": 1.5,
    "status": "planned"
  },
  {
    "id": "T2T-20",
    "name": "Expense & Reimbursement",
    "priority": "P2",
    "days": 1.5,
    "status": "planned"
  },
  {
    "id": "T2T-21",
    "name": "Vendor Performance Scorecard",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  },
  {
    "id": "T2T-22",
    "name": "Inventory & WMS Integration",
    "priority": "P2",
    "days": 2,
    "status": "planned"
  }
];

export const ARCH_FIXES = [
  {
    "id": "ARCH-01",
    "name": "RBAC — delegation (frontend)",
    "days": 0.3,
    "status": "complete",
    "detail": "Hide OOO from admin; add operations.delegate permission flag"
  },
  {
    "id": "ARCH-01b",
    "name": "RBAC — delegation (backend)",
    "days": 0.2,
    "status": "complete",
    "detail": "Gate delegation API routes with operations.delegate; exclude user-scope from admin bypass"
  },
  {
    "id": "ARCH-02a",
    "name": "Request Types foundation",
    "days": 2,
    "status": "complete",
    "detail": "New t2t_request_types + _fields tables; Admin UI; seed Vendor/PR/Leave"
  },
  {
    "id": "ARCH-02b-i",
    "name": "Workflow ↔ Request Type wiring",
    "days": 1,
    "status": "complete",
    "detail": "Add workflow.request_type_id; Builder picker; read-only Form Fields when attached"
  },
  {
    "id": "ARCH-02b-ii",
    "name": "Submit flow — Request Type first",
    "days": 1,
    "status": "complete",
    "detail": "Two-step New Request modal (pick Type → pick Workflow); persist request_type_id on t2t_requests (DEC-04)"
  },
  {
    "id": "ARCH-02b-iii",
    "name": "Submit/Detail page — request-type fields fallback + select/dropdown alias",
    "days": 0.5,
    "status": "complete",
    "detail": "When workflow has attached Request Type, Submit renders fields from wf.request_type.fields; Detail builds label map from same. Also resolve select vs dropdown type-name mismatch."
  },
  {
    "id": "ARCH-02b-iv",
    "name": "Multi-select Request Types on Workflow",
    "days": 0.5,
    "status": "complete",
    "detail": "Allow a workflow to be linked to multiple Request Types via junction table t2t_workflow_request_types. Builder shows multi-checkbox picker. NewRequestModal checks junction table. Submit shows type selector pill-buttons when >1 type."
  },
  {
    "id": "ARCH-03",
    "name": "Vendor self-registration",
    "days": 3,
    "status": "complete",
    "detail": "Public /vendor-signup page + admin approval queue; self-invites gate the existing vendor portal flow"
  },
  {
    "id": "ARCH-04",
    "name": "Conditions UX polish",
    "days": 1.5,
    "status": "complete",
    "detail": "Condition builder: field dropdown, operator help, validator-aware types"
  },
  {
    "id": "ARCH-05a",
    "name": "Integration stage — authoring",
    "days": 2,
    "status": "complete",
    "detail": "New \"System Action\" stage type; canvas palette + config UI for subtypes (sap_sync, ariba_push, fiori_sync, pan_validate, gst_validate, three_way_match, duplicate_check). No runtime execution yet."
  },
  {
    "id": "ARCH-05b",
    "name": "Integration stage — runtime executor",
    "days": 3,
    "status": "complete",
    "detail": "Dispatcher invokes the integration when a request enters a System Action stage. Branches on outcome. Retry + call-log."
  },
  {
    "id": "ARCH-06",
    "name": "Request Detail — type-aware widget rendering",
    "days": 0.5,
    "status": "complete",
    "detail": "Detail page hides widgets irrelevant to the request type (e.g. no Three-Way Match / GeM / TReDS on Vendor Creation or Leave)"
  },
  {
    "id": "ARCH-07",
    "name": "Builder — auto-scroll canvas to saved stages on load",
    "days": 0.1,
    "status": "complete",
    "detail": "Canvas opens to (0,0) even when stages are saved at unusual coordinates (e.g. y≈1280), making the workflow appear empty until user scrolls down"
  }
];
